/* ============================================================================
 * VELO — Cart enhancement layer  (Phase 1)
 * Listens for the theme's own `cart:updated` event and enhances the
 * JS-rendered cart drawer. Does NOT modify theme.js — fully additive.
 * Phase 1: free-shipping bar, trust line, gift message, dynamic gap-filler upsell.
 * Phase 2: per-item Subscribe & Save toggle + frequency dropdown (selling plans).
 * Remove this file + the VELO blocks in cart-drawer.liquid to fully revert.
 * ========================================================================== */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  // Tracks whether the cart was already over the threshold, so we only
  // celebrate on the moment of *crossing*, not on every cart refresh.
  var wasUnlocked = null;
  var lastTotal = 0; // last known cart total — lets us re-apply the bar after a drawer rebuild

  function celebrate(el) {
    el.classList.add('velo-freeship--won');
    var burst = document.createElement('div');
    burst.className = 'velo-confetti';
    var colors = ['#C8772E', '#1a7f37', '#E8B04B', '#2b2b2b', '#d98a3d'];
    for (var i = 0; i < 12; i++) {
      var s = document.createElement('span');
      var x = (Math.random() * 2 - 1) * 64;
      s.style.cssText =
        '--x:' + x.toFixed(0) + 'px;' +
        '--r:' + (Math.random() * 360 | 0) + 'deg;' +
        'background:' + colors[i % colors.length] + ';' +
        'animation-delay:' + (Math.random() * 90 | 0) + 'ms';
      burst.appendChild(s);
    }
    el.appendChild(burst);
    setTimeout(function () {
      el.classList.remove('velo-freeship--won');
      if (burst.parentNode) burst.parentNode.removeChild(burst);
    }, 1200);
  }

  function renderFreeShip(totalCents) {
    var el = document.querySelector('[data-velo-freeship]');
    if (!el) return;
    if (typeof totalCents === 'number') lastTotal = totalCents; else totalCents = lastTotal;

    // Promo mode: a site-wide free-shipping offer is running, so the countdown
    // is wrong (it would tell shoppers to spend more). Show a flat celebratory
    // message instead. Toggled from Theme settings → Cart → Free shipping bar.
    if (el.getAttribute('data-promo') === 'true') {
      if (!totalCents || totalCents <= 0) { el.innerHTML = ''; wasUnlocked = true; return; }
      var p = document.createElement('p');
      p.className = 'velo-freeship__msg velo-freeship__msg--done velo-freeship__msg--promo';
      p.textContent = el.getAttribute('data-promo-msg') || 'Free shipping on every order';
      el.innerHTML = '';
      el.appendChild(p);
      wasUnlocked = true; // never fire the crossing celebration in promo mode
      return;
    }

    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 5000;

    if (!totalCents || totalCents <= 0) { el.innerHTML = ''; wasUnlocked = false; return; }

    var remaining = threshold - totalCents;
    var pct = Math.min(100, Math.round((totalCents * 100) / threshold));
    var done = remaining <= 0;

    var msg = done
      ? '🎉 <span class="velo-strong">You\'ve unlocked free shipping!</span>'
      : 'You\'re <span class="velo-strong">' + money(remaining) +
        '</span> away from <span class="velo-strong">free shipping</span>';

    el.innerHTML =
      '<p class="velo-freeship__msg' + (done ? ' velo-freeship__msg--done' : '') + '">' + msg + '</p>' +
      '<div class="velo-freeship__track"><div class="velo-freeship__fill' +
        (done ? ' velo-freeship__fill--done' : '') + '" style="width:' + pct + '%"></div></div>';

    // Celebrate only when crossing from locked -> unlocked (not on first load).
    if (done && wasUnlocked === false) celebrate(el);
    wasUnlocked = done;
  }

  // Re-apply the header bar if a drawer rebuild left it empty (first-add race).
  function reapplyFreeShip() {
    var el = document.querySelector('[data-velo-freeship]');
    if (el && !el.innerHTML.trim() && lastTotal > 0) renderFreeShip(lastTotal);
  }

  // ---- Dynamic gap-filler upsell ---------------------------------------------
  var UPSELL = [];

  function parseUpsell() {
    var el = document.querySelector('[data-velo-upsell-data]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  function renderUpsell(cart, threshold) {
    var slot = document.querySelector('[data-velo-upsell-slot]');
    if (!slot) return;
    var gap = threshold - cart.total_price;
    if (gap <= 0 || !UPSELL.length) { slot.innerHTML = ''; return; }   // already free / nothing to show

    // Skip anything already in the cart, then sort cheapest → priciest.
    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[i.variant_id] = true; });
    var pool = UPSELL.filter(function (c) { return !inCart[c.id]; })
                     .sort(function (a, b) { return a.price - b.price; });
    if (!pool.length) { slot.innerHTML = ''; return; }

    // Smallest add that crosses the threshold; if none reaches it, the largest (gets closest).
    var pick = null;
    for (var i = 0; i < pool.length; i++) { if (pool[i].price >= gap) { pick = pool[i]; break; } }
    if (!pick) pick = pool[pool.length - 1];

    var crosses = pick.price >= gap;
    var head = crosses ? 'Add this — unlock FREE shipping' : 'Get closer to free shipping';

    slot.innerHTML =
      '<div class="velo-upsell__card">' +
        (pick.image ? '<img class="velo-upsell__img" src="' + pick.image + '" alt="" />' : '') +
        '<div class="velo-upsell__info">' +
          '<p class="velo-upsell__head">' + head + '</p>' +
          '<p class="velo-upsell__name">' + pick.label + ' · ' + money(pick.price) + '</p>' +
        '</div>' +
        '<button type="button" class="btn velo-upsell__add" data-velo-add="' + pick.id + '">Add</button>' +
      '</div>';
  }

  function bindUpsellClicks() {
    if (bindUpsellClicks._bound) return;
    bindUpsellClicks._bound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-velo-add]') : null;
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-velo-add');
      if (!id) return;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:build')); // theme re-renders line items + subtotal
          refresh();                                             // we update the bar + upsell ourselves
          //  ^ buildCart() does NOT dispatch cart:updated, so we can't rely on the event here.
        })
        .catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
    });
  }
  // ----------------------------------------------------------------------------

  function refresh() {
    var fs = document.querySelector('[data-velo-freeship]');
    var threshold = fs ? (parseInt(fs.getAttribute('data-threshold'), 10) || 5000) : 5000;
    var promo = fs ? fs.getAttribute('data-promo') === 'true' : false;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderFreeShip(cart.total_price);
        [150, 450, 900].forEach(function (d) { setTimeout(reapplyFreeShip, d); });
        // In promo mode the gap-filler upsell ("add this to unlock free shipping")
        // is misleading too, so clear it and skip rendering.
        if (promo) {
          var slot = document.querySelector('[data-velo-upsell-slot]');
          if (slot) slot.innerHTML = '';
        } else {
          renderUpsell(cart, threshold);
        }
        renderSavings(cart);
      })
      .catch(function () {});
  }

  // Gift message: write to the cart NOTE on blur so it lands in the order's
  // "Notes" section (cart.note -> order note). Also clears the legacy "Gift message"
  // cart attribute so it no longer shows under "Additional details".
  function bindGift() {
    var ta = document.querySelector('[data-velo-gift]');
    if (!ta || ta._veloBound) return;
    ta._veloBound = true;
    ta.addEventListener('blur', function () {
      var v = (ta.value || '').trim();
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          note: v,
          attributes: { 'Gift message': '' }
        })
      }).catch(function () {});
    });
  }

  // ---- Subscribe & Save -------------------------------------------------------
  // Convert a line to/from a subscription in-cart. selling_plan: '' = one-time (remove plan).
  function changeLine(key, qty, planId) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Number(qty) || 1, selling_plan: planId })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build')); // theme re-renders line items (with new price + state)
        refresh();                                             // and we refresh the bar + upsell
      })
      .catch(function () {});
  }

  function bindSubControls() {
    if (bindSubControls._bound) return;
    bindSubControls._bound = true;

    // "Subscribe & Save" CTA  +  "Switch to one-time" link
    document.addEventListener('click', function (e) {
      var on = e.target.closest ? e.target.closest('[data-velo-sub-on]') : null;
      if (on) {
        e.preventDefault();
        var w = on.closest('[data-velo-sub]');
        if (w) changeLine(w.getAttribute('data-key'), w.getAttribute('data-qty'), w.getAttribute('data-default-plan'));
        return;
      }
      var off = e.target.closest ? e.target.closest('[data-velo-sub-off]') : null;
      if (off) {
        e.preventDefault();
        var w2 = off.closest('[data-velo-sub]');
        if (w2) changeLine(w2.getAttribute('data-key'), w2.getAttribute('data-qty'), ''); // '' removes the plan
      }
    });

    // Frequency dropdown
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-velo-sub-freq]')) {
        var w = t.closest('[data-velo-sub]');
        if (w) changeLine(w.getAttribute('data-key'), w.getAttribute('data-qty'), t.value);
      }
    });
  }

  function renderSavings(cart) {
    var row = document.querySelector('[data-velo-savings-row]');
    var amt = document.querySelector('[data-velo-savings]');
    if (!row || !amt) return;

    var savings = 0;
    (cart.items || []).forEach(function (it) {
      // Regular line-level discounts (sales, cart discounts, etc.)
      var lineSave = (it.original_line_price || 0) - (it.final_line_price || 0);
      // Subscription savings live on the selling-plan allocation, not in original/final price.
      var a = it.selling_plan_allocation;
      if (a && typeof a.compare_at_price === 'number' && a.compare_at_price > a.price) {
        var subSave = (a.compare_at_price - a.price) * (it.quantity || 1);
        if (subSave > lineSave) lineSave = subSave;   // take the larger; don't double-count
      }
      if (lineSave > 0) savings += lineSave;
    });

    if (savings > 0) { amt.textContent = '−' + money(savings); row.hidden = false; }
    else { row.hidden = true; }
  }
  // ----------------------------------------------------------------------------

  function watchFreeShip() {
    var target = document.getElementById('CartDrawer') || document.body;
    if (!target || target.__veloFsWatch) return;
    target.__veloFsWatch = true;
    new MutationObserver(reapplyFreeShip).observe(target, { childList: true, subtree: true });
  }

  function init() { UPSELL = parseUpsell(); refresh(); bindGift(); bindUpsellClicks(); bindSubControls(); watchFreeShip(); }

  // Re-run whenever the theme finishes rebuilding the cart, and once on load.
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('ajaxProduct:added', refresh); // Impulse fires this (not cart:updated) on add-to-cart
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
